<template>
  <div class="slot-input">
    <el-input
      :key="key"
      :type="inputType"
      :showPassword="false"
      :maxlength="maxlength"
      class="slot-input-wrapper"
      :style="'padding-right:'+rightWidth+'px'"
      v-model="inputValue"
      :placeholder="placeholder"
      @focus="onFocus"
      @input="onInputChange"
    >
    </el-input>
    <div class="slot-right">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: [String, Number],
      default: ''
    },
    position: {
      type: String,
      default: 'right'
    },
    placeholder: {
      type: String,
      default: ''
    },
    rightWidth: {
      type: Number,
      default: 0
    },
    showPw: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: [Number, Boolean],
      default: false
    }
  },
  data() {
    return {
      inputValue: '',
      inputType: 'text',
      key: Date.now(),
    };
  },
  watch: {
    value(val) {
      this.inputValue = val
    },
    showPw: {
      handler(val) {
        this.inputType = val ? 'password' : 'text'
      },
      immediate: true
    }
  },
  methods: {
    onFocus(e) {
      this.$emit('onFocus', e)
    },
    onInputChange(e) {
      const value = this.type == 'number' ? e.replace(/[^0-9]/g, '') : e
      this.inputValue = value
      this.$emit('onInputChange', value)
      this.$emit('update:value', value)
    },
  },
  mounted() {

  }
};
</script>
<style lang="scss" scoped>
.slot-input {
  position: relative;
  width: 100%;
  background-color: #f3f5f9;
  border-radius: 4px;
}
.slot-input-wrapper {
  >>> .el-input__inner {
    background: transparent;
    border: none;
    padding: 1px 10px;
    box-shadow: none;
    height: 42px;
    outline: none;
    :focus{
      outline: none;
    }
  }
}
.slot-right {
  position: absolute;
  right: 12px;
  top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/Login/components/SlotInput.vue